(() => {
  'use strict';

  const fixProductGallerySemantics = (scope = document) => {
    scope.querySelectorAll('.bw-product-gallery__thumbnails[role="list"]').forEach((element) => {
      element.removeAttribute('role');
    });

    scope.querySelectorAll('.bw-product-gallery__thumbnail[role="listitem"]').forEach((button) => {
      button.removeAttribute('role');
    });
  };

  const addAccessibilityTouchStyles = () => {
    if (document.getElementById('bathwise-accessibility-touch-styles')) return;

    const style = document.createElement('style');
    style.id = 'bathwise-accessibility-touch-styles';
    style.textContent = `
      #MainContent .bw-hero__dot {
        position: relative;
        width: 32px !important;
        height: 44px !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
      }
      #MainContent .bw-hero__dot::before {
        content: '';
        position: absolute;
        left: 2px;
        right: 2px;
        top: 50%;
        height: 2px;
        transform: translateY(-50%);
        background: rgba(255,255,255,.48);
      }
      #MainContent .bw-hero__dot.is-active::before { background: #fff; }
      .bw-showroom-carousel__arrow { min-width: 44px; min-height: 44px; }
      .bw-showroom__more-button,
      .bw-showroom__no-results button,
      .bw-brand__link,
      .bw-brands__toggle button,
      .bw-topbar__link,
      .bw-filter summary,
      .bw-collection-filters__actions .bw-button,
      .bw-active-filters a,
      .bw-sort select { min-height: 44px; }
      .bw-menu { min-width: 44px; min-height: 44px; padding: 0; }
      .bw-global-search__input { height: 44px; }
      @media (max-width: 650px) {
        .bw-showroom-carousel__arrow { width: 44px !important; height: 44px !important; }
      }
      @media (max-width: 560px) {
        .bw-global-search__input { height: 44px !important; }
      }
    `;
    document.head.appendChild(style);
  };

  const getOpenShowroomDialog = () => {
    const modal = document.querySelector('.bw-showroom-modal.is-open');
    if (!modal) return null;
    return modal.querySelector('[role="dialog"]');
  };

  const getFocusableElements = (dialog) => {
    if (!dialog) return [];
    return Array.from(dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => {
      if (element.closest('[hidden]')) return false;
      const style = window.getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
    });
  };

  const trapShowroomModalFocus = (event) => {
    if (event.key !== 'Tab') return;

    const dialog = getOpenShowroomDialog();
    if (!dialog) return;

    const focusable = getFocusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (!dialog.contains(active)) {
      event.preventDefault();
      first.focus();
      return;
    }

    if (event.shiftKey && (active === first || active === dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const initialise = () => {
    const main = document.getElementById('MainContent');
    if (main) main.setAttribute('tabindex', '-1');
    fixProductGallerySemantics(document);
    addAccessibilityTouchStyles();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('keydown', trapShowroomModalFocus);

  document.addEventListener('shopify:section:load', (event) => {
    fixProductGallerySemantics(event.target);
    addAccessibilityTouchStyles();
  });
})();
